export default __webpack_public_path__ + "static/media/globe-icon.bee24960.svg";